import { useAddOrEditFunctionaryPage } from './useAddOrEditFunctionaryPage';
import { FunctionaryDetailsForm } from '../../../components/FunctionaryDetailsForm';

export const AddOrEditFunctionaryPageContainer = () => {
	const {
		form,
		functionary,
		onSubmitClick,
		onCancelClick,
		submitButtonDisabled,
		isEditFormStatus,
		functionarySrcmIdParam,
	} = useAddOrEditFunctionaryPage();

	return (
		<div className="flex flex-col px-[8px]">
			<FunctionaryDetailsForm
				form={form}
				functionary={functionary}
				isEditForm={isEditFormStatus}
				onAddEditFunctionarySubmit={onSubmitClick}
				onCancelClick={onCancelClick}
				submitButtonDisabled={submitButtonDisabled}
				functionarySrcmIdParam={functionarySrcmIdParam}
			/>
		</div>
	);
};
